module.exports = __webpack_public_path__ + "img/slide-1-tab.c78abb6.webp";